module.exports = __webpack_public_path__ + "static/chronx-c7694dcb6eacb81670cc2239f52b7c2b.jpg";